import classNames from 'classnames';
import { Form, Formik } from 'formik';
import React from 'react';
import { useTranslation } from '../../../../i18n/use-translation';
import { Button } from '../../../atoms/button';
import { SmallPreloader } from '../../../atoms/preloaders/smal_preloader';
import { Color } from '../../../enums/color';
import { Size } from '../../../enums/size';
import { Checkbox } from '../../../molecules/Checkbox';
import { Input } from '../../../molecules/Input';
import { useViewModel } from './hook/use-view-model';
import * as styles from './login.module.sass';
import { getDefaultSignParams } from './res/default_params';
import { getSignatureValidation } from './res/schema';
import { LoginProps } from './type/porps';

export const LoginForm = (props: LoginProps) => {
  const { t } = useTranslation();
  const { isLoading, resetPasswordClickHandler, formSubmitHandler } = useViewModel();




  return (
    <div className={styles.form_wrapper}>
      <Formik
        initialValues={{ ...getDefaultSignParams() }}
        validationSchema={getSignatureValidation()}
        onSubmit={formSubmitHandler}
      >
        <Form>
          <Input
            name="_username"
            label={t('phone_number')}
            placeholder={t('phone_number_placeholder')}
            required
          />
          <Input
            name="_password"
            type="password"
            label={t('password')}
            placeholder={t('password_placeholder_sign')}
            required
          />
          <div className={styles.footer_form}>
            <Checkbox label={t('remember')} name="approve_age" />

            <Button
              color={Color.EMPTYALL}
              type="button"
              text={t('forgot_pass')}
              textClassName={styles.forgot_button}
              onClick={resetPasswordClickHandler}
            />
          </div>
          {isLoading ? (
            <SmallPreloader />
          ) : (
            <Button type="submit" text={t('sign_in_button')} size={Size.BIG} className={styles.modal_button} />
          )}
        </Form>
      </Formik>
      <p>{t('sign_with')}</p>

      <div className={styles.social_links_wrap}>
        <a
          href={`https://accounts.google.com/o/oauth2/auth?response_type=code&access_type=online&client_id=976144271696-7krurkdfa2ht0csegljd4p8b482rtdkb.apps.googleusercontent.com&redirect_uri=https%3A%2F%2Fdev.moniheal.com%2Fsocial-data-handler&state=%7B%22action%22%3A%22login%22%2C%22social%22%3A%22google%22%2C%22locale%22%3A%22uk%22%7D&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.profile&approval_prompt=auto`}
          className={classNames(styles.social_btn, styles.social_btn__fb, styles.button_icon)}
          data-cy="login-fb-btn"
        >
          <img src="/public-assets/img/badges/fb-dropdown-icon.svg" alt="fb-icon" />
          <span>Facebook</span>
        </a>
        <a
          href="https://www.facebook.com/v8.0/dialog/oauth?client_id=207605933491218&state=%7B%22action%22%3A%22login%22%2C%22social%22%3A%22facebook%22%2C%22locale%22%3A%22uk%22%7D&response_type=code&sdk=php-sdk-5.7.0&redirect_uri=https%3A%2F%2Fdev.moniheal.com%2Fsocial-data-handler&scope=publish_actions%2Cemail"
          id="appleid-signin"
          className={classNames(styles.social_btn, styles.social_btn__apple, styles.button_icon)}
          data-cy="login-apple-btn"
        >
          <img src="/public-assets/img/badges/apple.png" alt="apple-icon" />
          <span>Apple ID</span>
        </a>
        <a
          href="https://www.facebook.com/v8.0/dialog/oauth?client_id=207605933491218&state=%7B%22action%22%3A%22login%22%2C%22social%22%3A%22facebook%22%2C%22locale%22%3A%22uk%22%7D&response_type=code&sdk=php-sdk-5.7.0&redirect_uri=https%3A%2F%2Fdev.moniheal.com%2Fsocial-data-handler&scope=publish_actions%2Cemail"
          className={classNames(styles.social_btn, styles.social_btn__google, styles.button_icon)}
          data-cy="login-google-btn"
        >
          <img src="/public-assets/img/badges/google-dropdown-icon.svg" alt="google-icon" />
          <span>Google</span>
        </a>
      </div>
    </div>
  );
};
